import { cn } from '@/utils/cn';
import { useSeasonTable } from '@/context/LivescoreSeasonTableContext';
import { Types } from '@/context/LivescoreSeasonTableContext';

const types: { label: string; value: Types }[] = [
  {
    label: 'OGÓLNA',
    value: 'total',
  },
  {
    label: 'U SIEBIE',
    value: 'home',
  },
  {
    label: 'NA WYJEŹDZIE',
    value: 'away',
  },
];

const LivescoreSeasonTableTypePicker = () => {
  const { type, setType, showForm, setShowForm, seasonTable } = useSeasonTable();
  return (
    <div className="w-full rounded-full sm:px-3 px-1.5 py-1 sm:py-1.5 flex items-center text-xxs text-gray-400 font-semibold gap-2">
      <div className="dark:bg-gray-650 bg-white_theme-100 w-full rounded-full sm:px-3 px-1.5 py-1 sm:py-1.5 flex items-center text-xxs text-gray-400 font-semibold gap-2">
        {types.map(
          ({ label, value }) =>
            seasonTable?.[value] &&
            Object.keys(seasonTable?.[value]).length > 0 && (
              <button
                onClick={() => setType(value)}
                key={value}
                className={cn(
                  'w-full py-2 rounded-full border border-transparent transition-all sm:text-xxs text-[8px]',
                  type === value &&
                    ' dark:bg-black-500 bg-white border dark:border-border-400 border-white_theme-100 text-primary-600',
                )}
              >
                {label}
              </button>
            ),
        )}
      </div>
      <button
        onClick={() => setShowForm((prev) => !prev)}
        className={cn(
          'py-2 rounded-full border border-transparent transition-all sm:text-xxs text-[8px] flex items-center gap-2',
        )}
      >
        FORMA
        <div className="h-7 w-12 rounded-full dark:bg-gray-450 bg-gray-250 relative">
          <span
            className={cn(
              'bg-white dark:bg-black w-5 h-5 rounded-full absolute top-1 transition-all',
              showForm ? 'right-1 bg-primary-600 dark:bg-primary-600' : 'right-6',
            )}
            aria-hidden
          />
        </div>
      </button>
    </div>
  );
};

export default LivescoreSeasonTableTypePicker;
